export const GET_STATUSS = "GET_STATUSS";
export const ADD_STATUS = "ADD_STATUS";
export const EDIT_STATUS = "EDIT_STATUS";
export const GET_STATUS = "GET_STATUS";
export const RESET_STATUS = "RESET_STATUS";
export const ERROR_STATUS = "ERROR_STATUS";
export const GET_ALL_STATUSS = "GET_ALL_STATUSS";
